import {View} from "backbone.marionette";
import _ from "underscore";
import _template from "../../../app/library/_template";
import Factory from "../../../app/library/map/Factory";
import MapListener from "../../../app/library/map/listener/MapListener";

const MapModuleView = View.extend({

    template: _template('#app_map_module_template'),

    ui: {
        'map': '.app-map'
    },
    collectionEvents: {
        'sync': 'updateMarkers'
    },

    mapListener: null,

    initialize: function () {
        this.mapListener = new MapListener(
            _.bind(this.onBoundsChanged, this),
            _.bind(this.onMarkerClicked, this),
            _.bind(this.onMapClicked, this)
        );
    },

    updateMarkers() {
        this.map.clearMarkers();

        this.collection.each((marker) => {
            if (marker.get('type') === 'marker') {
                this.map.addMarker(marker.get('point').lat, marker.get('point').lng, marker.get('value'), marker.get('data'));
            } else {
                this.map.addCluster(marker.get('point').lat, marker.get('point').lng, marker.get('count'), marker.get('value'));
            }
        });
    },

    onDomRefresh: function () {
        this.initMap();
    },

    initMap: function () {
        this.map = Factory.getMap({
            listener: this.mapListener
        });

        let params = {
            center: this.getOption('center'),
            scrollZoom: true
        };
        if (this.getOption('zoom')) {
            params.zoom = this.getOption('zoom');
        }
        if (this.getOption('bound')) {
            params.bound = this.getOption('bound');
        }
        this.map.attachMap(this.ui.map, params);
    },

    onBoundsChanged: function (bounds, zoom) {
        this.trigger('bounds:changed', bounds, zoom);
    },

    onMarkerClicked: function (lat, lng, locationId, login) {
        this.trigger('marker:clicked', login, locationId);
    },

    onMapClicked: function () {
        this.trigger('map:clicked');
    },

    highlightMarker: function (id) {
        return this.map.highlightMarker(id);
    },

    unHighlightMarker: function (id) {
        return this.map.unHighlightMarker(id);
    },

    unHighlightMarkers: function () {
        return this.map.unHighlightMarkers();
    },

    flyTo: function (lng, lat) {
        this.map.flyTo(lng, lat);
    },

    zoomTo: function (zoom) {
        this.map.zoomTo(zoom);
    }

});

export default MapModuleView;